import { EventEmitter, Output } from '@angular/core';
import { RoutesChange } from './../../../model/services/routes.service';
import { RoutesService } from 'app/model/services/routes.service';
import { SubMode } from 'app/components/reports/reports.component';
import { AttributeInfo, ConfigAttribute } from './../../../types/project-config';
import { ObjID } from './../../../model/id-manager';
import { CostReportService } from './../../../model/services/cost-report.service';
import { Route } from './../../../types/route-data';
import { DataManagerService, RouteTally, FeatureSelection } from './../../../model/services/data-manager.service';
import { ChangeDetectionStrategy, Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { ReportingService } from 'app/model/services/reporting.service';

@Component({
  selector: 'app-report-summary',
  templateUrl: './report-summary.component.html',
  styleUrls: ['./report-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportSummaryComponent implements OnInit {


  public mode: SubMode = '*';
  private _route?: Route;
  @Input('route')
  set route(route: Route | undefined) {
    this._route = route;
    // console.log(this.features);
    window.requestAnimationFrame(() => {
      this.ProcessRoute();
    });
    this.Refresh();

  }
  get route(): Route | undefined {
    return this._route;
  }

  get tallyKeys(): Array<string> {
    if (!this.tally) return [];
    return Object.keys(this.tally).sort();

  }
  public tally?: RouteTally;
  @Output()
  public tallyChange = new EventEmitter<RouteTally>();

  private _ready: boolean = false;
  constructor(
    private dataMgr: DataManagerService,
    private cdr: ChangeDetectorRef,
    private rpt: CostReportService,
    private rpts:ReportingService) { }

  ProcessRoute() {
    if (!this._route) return;
    const mode: SubMode = (this._route.expanded === true) ? '*' : '*+';
    this.tally = this._route.feature.GetTally(mode,this._route.id, this._route);
    this.tallyChange.emit(this.tally);
    console.log('Processing Route for summary report', this.tally);
    this.Refresh();
  }

  ngOnInit(): void {
    this._ready = true;
    this.rpts.SetSummaryComponent(this);
    this.dataMgr.onFeatureUpdate.subscribe((selection: FeatureSelection) => {
      this.cdr.markForCheck();
      this.Refresh();
    })
    RoutesService.onChange.subscribe((changeInfo: RoutesChange) => {
      if (changeInfo.change === 'route-change') {
        if (this.route?.id as number !== changeInfo.route) return;
        this.UpdateMode();
        this.Refresh();
        return;
      }
      if(changeInfo.change === 'route-vis-changed') {
        this.ProcessRoute();
      }
    });
  }
  public HasValue(key: any): boolean {
    const att = this.dataMgr.GetProject()?.idRegistry.Get(key) as ConfigAttribute;
    return this.GetTallyItem(key, 'cost') !== '';
  }
  public GetAttributeName(key: any): string {
    const att = this.dataMgr.GetProject()?.idRegistry.Get(key) as ConfigAttribute;
    return att.label;
  }
  public GetTallyItem(key: any, item: 'labor' | 'materials' | 'length' | 'qty' | 'cost'): string {
    if (!this.tally) return '';
    const itemTally = this.tally[key];
    switch (item) {
      case 'labor':
      case 'materials':
        if (!this.tally[key]?.costs[item]) return '';
        return this.FormatDollars(this.tally[key]!.costs[item]!);
      case 'length':
        if (!this.tally[key]?.costs[item]) return '';
        return this.FormatDistance(this.tally[key]!.costs[item]!);

      case 'qty':
        if (!this.tally[key]) return '';
        return this.FormatQty(this.tally[key]!.qty);
      case 'cost':
        if (!this.tally[key]) return '';
        return this.FormatDollars(this.tally[key]!.total);
    }
    return '';
  }

  FormatQty(val: any) {
    return this.Format(val, '', '', 0, 'up');
  }

  FormatDistance(val: any) {
    return this.Format(val, '', 'feet', 0);
  }

  FormatDollars(val: any) {
    return this.Format(val, '$', '', 2);
  }
  Format(val: any, prefix: string = '', units = '', fixed = 2, round: 'normal' | 'down' | 'up' = 'normal') {
    let str = '' + val;
    if (val === undefined) return '';
    if (val === 0) return '';
    if (val === '') return '';
    const dollarAndCents = str.split('.');
    if (fixed === 0) {
      switch (round) {
        case 'up':
          val = Math.ceil(val);
          break;
        case 'down':
          val = Math.floor(val);
          break;
        default:
          val = Math.round(val);
      }
    }
    str = prefix + String(dollarAndCents[0]).replace(/(.)(?=(\d{3})+$)/g, '$1' + ',');
    if (fixed !== 0) {
      str += dollarAndCents.length === 1 ? '.' + Number('.00').toFixed(fixed).split('.').pop() : '.' + Number('.' + dollarAndCents[1]).toFixed(fixed).split('.').pop();
    }
    str += ' ' + units;
    return str;
  }
  UpdateMode(mode?: SubMode) {
    const oldMode = this.mode;
    if (!!mode) {
      if (this.mode === '<*>') {
        return;
      }
      this.mode = mode;
      if (oldMode !== this.mode) {
        if(!this._route) return;
        this.ProcessRoute();
      }
      this.Refresh();

      return;
    }
    this.mode = this.route?.expanded ? '*' : '*+';
    if (oldMode !== this.mode) {
      if(!this._route) return;
      this.ProcessRoute();
    }
  }
  Refresh() {
    if (!this._ready) return;
    this.cdr.detectChanges();
  }

}
